import { failToast } from './failToast';

/**
 * 저장 호출의 결과를 기다려 성공했는지 알려 준다. 입력을 비우거나 창을 닫는 쪽은 `true` 일 때만 그렇게 한다.
 *
 *   if (await saveSucceeded(() => onSubmit(text), '메모를 남기지 못했어요')) setText('');
 *
 * 실패하면 입력은 그대로 남고 `failTitle` 이 있으면 실패 토스트를 띄운다. 이미 자기 `onError` 로 알리는
 * 저장은 `failTitle` 을 넘기지 않는다(토스트가 두 번 뜬다). 저장 쪽은 `mutateAsync` 의 약속을 돌려줘야 한다
 * — `mutate` 를 부르고 아무것도 돌려주지 않으면 실패해도 성공으로 읽힌다.
 */
export async function saveSucceeded(save: () => unknown, failTitle?: string): Promise<boolean> {
  try {
    await save();
    return true;
  } catch (error) {
    if (failTitle) failToast(failTitle, error);
    return false;
  }
}
